import useSWR from "swr";
import type { Information } from "@/shared/lib/api/api-client";
import { apiClient } from "@/shared/lib/api/api-client";

interface UseInformationsReturn {
	informations: Information[];
	loading: boolean;
	error: Error | null;
	refetch: () => Promise<void>;
}

const fetchInformations = async () => {
	const result = await apiClient.information.list();
	return result.data?.informationList || [];
};

export const useInformation = (): UseInformationsReturn => {
	const { data, error, isLoading, mutate } = useSWR<Information[]>(
		"informations",
		fetchInformations,
		{
			revalidateOnFocus: false,
			revalidateOnReconnect: true,
		},
	);

	const refetch = async () => {
		await mutate();
	};

	return {
		informations: data || [],
		loading: isLoading,
		error: error || null,
		refetch,
	};
};
